import { MessageCircle } from 'lucide-react';
import { brand } from '../config/brand';

/**
 * The floating "talk to a human" affordance. Every dead-end screen promises it,
 * so it has to exist on every breakpoint.
 *
 * It renders nothing at all when the owner has not supplied a channel: a chat
 * button that opens `#` is worse than no chat button, because a customer whose
 * money is stuck clicks it first.
 */
export function ChatButton() {
  const channels = [
    { url: brand.whatsappUrl, label: 'Chat admin lewat WhatsApp' },
    { url: brand.messengerUrl, label: 'Chat admin lewat Messenger' },
  ].filter((channel): channel is { url: string; label: string } => Boolean(channel.url));

  if (channels.length === 0) return null;

  // Di bawah 768px tombol ini duduk di atas sticky bar `/jasa/belanja`
  // (`fixed bottom-0`, z-30). Pada `bottom-5` ia menutupi sisi kanan tombol
  // submit — CTA primer yang tertutup FAB adalah target sentuh yang hilang.

  return (
    <div className="fixed bottom-[96px] right-5 z-40 flex flex-col gap-3 md:bottom-5">
      {channels.map((channel) => (
        <a
          key={channel.url}
          href={channel.url}
          target="_blank"
          rel="noreferrer noopener"
          aria-label={channel.label}
          title={channel.label}
          className="inline-flex h-[52px] w-[52px] items-center justify-center rounded-pill bg-ink text-white no-underline transition-colors duration-150 ease-out hover:bg-ink/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ink focus-visible:ring-offset-2"
        >
          <MessageCircle size={22} aria-hidden="true" />
        </a>
      ))}
    </div>
  );
}

export default ChatButton;
